export default __webpack_public_path__ + "static/media/tags.a5329f7c.svg";